import { useEffect, useState } from 'react';
import { mobilizeiSubscriptionsService } from '../services/mobilizei/subscriptions.service';
import { subscriptionStatus } from '../utils/constants';

const POLLING_INTERVAL_MS = 5000;
const POLLING_TIMEOUT_MS = 15 * 60 * 1000;

/**
 * Polls the subscription until it becomes active, so the checkout can move to the
 * success screen as soon as a Pix payment is confirmed by the Iugu webhooks.
 * Stops after a while to avoid polling forever on an abandoned page.
 */
export default function useSubscriptionActivation(subscriptionId, enabled) {
    const [subscription, setSubscription] = useState(null);
    const [hasTimedOut, setHasTimedOut] = useState(false);

    const isActive = subscription?.status === subscriptionStatus.ACTIVE;

    useEffect(() => {
        if (!enabled || !subscriptionId || isActive) {
            return;
        }

        let cancelled = false;
        const startedAt = Date.now();

        const intervalId = setInterval(() => {
            if (Date.now() - startedAt > POLLING_TIMEOUT_MS) {
                clearInterval(intervalId);
                setHasTimedOut(true);
                return;
            }

            mobilizeiSubscriptionsService.getById(subscriptionId)
                .then(response => {
                    if (!cancelled) setSubscription(response);
                })
                .catch(() => null);
        }, POLLING_INTERVAL_MS);

        return () => {
            cancelled = true;
            clearInterval(intervalId);
        };
    }, [subscriptionId, enabled, isActive]);

    return { subscription, isActive, hasTimedOut };
}
